/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchContainersHashrateResponse } from './search-containers-hashrate-response';
import { SearchContainersEquipmentCountPerStatusResponse } from './search-containers-equipment-count-per-status-response';
import { SearchContainersRackResponse } from './search-containers-rack-response';
import { SearchContainersFacilityResponse } from './search-containers-facility-response';


export interface SearchContainersResponse { 
    id: string;
    number: number;
    name: string;
    subnet: string;
    racksCount: number;
    energyConsumption: number;
    freePlacesCount: number;
    equipmentsInRepairCount: number;
    offlineEquipmentsCount: number;
    facility: SearchContainersFacilityResponse;
    hashrateInHashes: SearchContainersHashrateResponse;
    hashrateInSolutions: SearchContainersHashrateResponse;
    equipmentsCountByStatus: Array<SearchContainersEquipmentCountPerStatusResponse>;
    racks: Array<SearchContainersRackResponse>;
}

